import { render, staticRenderFns } from "./TRKExtrasView.vue?vue&type=template&id=2d026035"
import script from "./TRKExtrasView.vue?vue&type=script&lang=js"
export * from "./TRKExtrasView.vue?vue&type=script&lang=js"
import style0 from "./TRKExtrasView.vue?vue&type=style&index=0&id=2d026035&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports